<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-print"></i></div>
          <div>
            <div class="panel-title">Release Form</div>
            <div class="panel-sub">TCN: {{ $route.params.tcn }}</div>
          </div>
        </div>
        <div class="panel-header-right">
          <button class="btn-back" @click="goBack">
            <i class="fa fa-arrow-left"></i> Back to List
          </button>
        </div>
      </div>

      <!-- Body -->
      <div class="panel-body">
        <div class="pdf-skeleton" v-if="dataLoading">
          <div class="sk-page">
            <!-- Header block -->
            <div class="sk-header-block">
              <div class="sk-logo"></div>
              <div class="sk-header-lines">
                <div class="sk-line" style="width:55%"></div>
                <div class="sk-line" style="width:35%; margin-top:6px;"></div>
              </div>
            </div>
            <div class="sk-divider"></div>
            <!-- Title -->
            <div class="sk-line sk-title" style="width:45%; margin:0 auto 20px;"></div>
            <!-- Body lines -->
            <div class="sk-section">
              <div class="sk-line" style="width:100%"></div>
              <div class="sk-line" style="width:92%"></div>
              <div class="sk-line" style="width:97%"></div>
              <div class="sk-line" style="width:85%"></div>
              <div class="sk-line" style="width:90%"></div>
            </div>
            <div class="sk-section">
              <div class="sk-line" style="width:100%"></div>
              <div class="sk-line" style="width:88%"></div>
              <div class="sk-line" style="width:94%"></div>
            </div>
            <!-- Two-column field rows -->
            <div class="sk-fields">
              <div class="sk-field-pair" v-for="n in 6" :key="n">
                <div class="sk-field-label"></div>
                <div class="sk-field-value" :style="{ width: (45 + (n * 9) % 30) + '%' }"></div>
              </div>
            </div>
            <div class="sk-divider"></div>
            <!-- Signature block -->
            <div class="sk-sig-row">
              <div class="sk-sig-box"></div>
              <div class="sk-sig-box"></div>
            </div>
          </div>
          <div class="sk-label-text">
            <span class="sk-dot"></span> Fetching document…
          </div>
        </div>
        <div class="error-box" v-else-if="loadError">
          <i class="fa fa-exclamation-circle"></i>
          <p>Unable to load the PDF. Please try again or go back.</p>
          <button class="btn-retry" @click="fetchTcnPdf">
            <i class="fa fa-redo"></i> Retry
          </button>
        </div>
        <iframe v-else :src="tcnPdf" class="pdf-frame">
          Your browser does not support PDF preview.
        </iframe>
      </div>

    </div>
  </div>
</template>

<script>
import { FETCH_PDF_TCN } from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
export default {
  components: {},
  data() {
    return {
      dataLoading: true,
      loadError: false,
      tcnPdf: "",
      breadCrumbs: [
        { id: 1, title: "Dashboard",       route: "client.dashboard" },
        { id: 2, title: "Enrollment List", route: "client.storeforward" },
        { id: 3, title: "Release Form",    route: "" },
      ],
    };
  },
  created() {
    this.fetchTcnPdf();
  },
  mounted() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "client.storeforward",
        params: { client_slug: this.$route.params.client_slug },
      });
    },
    fetchTcnPdf() {
      this.dataLoading = true;
      this.loadError = false;
      this.$store.dispatch(FETCH_PDF_TCN, this.$route.params.tcn)
        .then(data => {
          const blob = new Blob([data], { type: "application/pdf" });
          this.tcnPdf = URL.createObjectURL(blob);
          this.dataLoading = false;
        })
        .catch(() => {
          this.dataLoading = false;
          this.loadError = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #eef0f6;

.page-wrap {
  padding: 8px 0 80px;
  font-family: $font;
}

.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #fafbfd;
  border-bottom: 1px solid $border;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: $blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: $dark;
}

.panel-sub {
  font-size: 11px;
  color: #8a94a6;
  margin-top: 2px;
  font-family: 'Courier New', monospace;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border-radius: 7px;
  border: 1.5px solid $border;
  background: #fff;
  color: #4a5568;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: $blue;
    color: $blue;
  }
}

.panel-body {
  flex: 1;
  min-height: 0;
}

.error-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  gap: 12px;
  color: #8a94a6;
  font-size: 13px;

  i { font-size: 32px; color: #c62828; }
  p { margin: 0; }
}

/* ── PDF skeleton ── */
@keyframes shimmer {
  0%   { background-position: -700px 0; }
  100% { background-position:  700px 0; }
}

%sk {
  border-radius: 4px;
  background: linear-gradient(90deg, #e8ebf2 25%, #f3f5f9 50%, #e8ebf2 75%);
  background-size: 700px 100%;
  animation: shimmer 1.5s infinite linear;
}

.pdf-skeleton {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px 40px;
  background: #e9ecf2;
  min-height: calc(100vh - 140px);
}

.sk-page {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 24px rgba(13, 27, 62, 0.14);
  width: 100%;
  max-width: 680px;
  padding: 40px 48px;
}

.sk-header-block {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.sk-logo {
  @extend %sk;
  width: 56px;
  height: 56px;
  border-radius: 6px;
  flex-shrink: 0;
}

.sk-header-lines {
  flex: 1;
}

.sk-divider {
  @extend %sk;
  height: 2px;
  margin: 18px 0;
  border-radius: 2px;
}

.sk-title {
  height: 16px !important;
  border-radius: 6px !important;
}

.sk-line {
  @extend %sk;
  height: 10px;
  margin-bottom: 8px;
  border-radius: 3px;

  &:last-child { margin-bottom: 0; }
}

.sk-section {
  margin-bottom: 20px;
}

.sk-fields {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.sk-field-pair {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sk-field-label {
  @extend %sk;
  width: 110px;
  height: 10px;
  border-radius: 3px;
  flex-shrink: 0;
}

.sk-field-value {
  @extend %sk;
  height: 10px;
  border-radius: 3px;
}

.sk-sig-row {
  display: flex;
  gap: 24px;
  margin-top: 8px;
}

.sk-sig-box {
  @extend %sk;
  flex: 1;
  height: 48px;
  border-radius: 4px;
}

.sk-label-text {
  margin-top: 16px;
  font-size: 12px;
  color: #8a94a6;
  display: flex;
  align-items: center;
  gap: 7px;
}

.sk-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: $blue;
  animation: pulse 1.2s infinite ease-in-out;
  display: inline-block;
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: 0.4; transform: scale(0.7); }
}

.btn-retry {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border-radius: 7px;
  border: none;
  background: $blue;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  margin-top: 8px;

  &:hover { opacity: 0.9; }
}

.pdf-frame {
  width: 100%;
  height: calc(100vh - 140px);
  border: none;
  display: block;
}
</style>
